import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/stores/auth';
import { CryptoProvider } from './lib/stores/crypto';
import WithDomainProviders from './components/WithDomainProviders';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Auth from './pages/Auth';
import VerifyEmail from './pages/VerifyEmail';
import Unlock from './pages/Unlock';
import Home from './pages/Home';
import Foundation from './pages/Foundation';
import Goals from './pages/Goals';
import GoalDetail from './pages/GoalDetail';
import Ikigai from './pages/Ikigai';
import Values from './pages/Values';
import LifeWheel from './pages/LifeWheel';
import Vision from './pages/Vision';
import Decisions from './pages/Decisions';
import DecisionDetail from './pages/DecisionDetail';

function App() {
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log('Environment:', import.meta.env.VITE_ENVIRONMENT);
      console.log('API URL:', import.meta.env.VITE_API_URL);
    }
  }, []);

  return (
    <AuthProvider>
      <CryptoProvider>
        <BrowserRouter>
          <Routes>
            {/* Public — no domain providers */}
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/unlock" element={<Unlock />} />

            {/* Authenticated — wrapped in domain providers */}
            <Route path="/home" element={
              <WithDomainProviders><Layout><Home /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/foundation" element={
              <WithDomainProviders><Layout><Foundation /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/ikigai" element={
              <WithDomainProviders><Layout><Ikigai /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/values" element={
              <WithDomainProviders><Layout><Values /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/wheel" element={
              <WithDomainProviders><Layout><LifeWheel /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/vision" element={
              <WithDomainProviders><Layout><Vision /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/goals" element={
              <WithDomainProviders><Layout><Goals /></Layout></WithDomainProviders>
            } />
            <Route path="/purpose/goals/:goalId" element={
              <WithDomainProviders><Layout><GoalDetail /></Layout></WithDomainProviders>
            } />
            <Route path="/tools/decisions" element={
              <WithDomainProviders><Layout><Decisions /></Layout></WithDomainProviders>
            } />
            <Route path="/tools/decisions/:decisionId" element={
              <WithDomainProviders><Layout><DecisionDetail /></Layout></WithDomainProviders>
            } />
          </Routes>
        </BrowserRouter>
      </CryptoProvider>
    </AuthProvider>
  );
}

export default App;
